// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries

// export const baseUrl = api_url;
export const createUrl = (baseUrl: string, url: string): string => {
  const hostURL = baseUrl;
  return `${hostURL}${url}`;
};
